import { render, staticRenderFns } from "./TravelComponent.vue?vue&type=template&id=4fcce4a2&scoped=true"
import script from "./TravelComponent.vue?vue&type=script&lang=js"
export * from "./TravelComponent.vue?vue&type=script&lang=js"
import style0 from "./TravelComponent.vue?vue&type=style&index=0&id=4fcce4a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcce4a2",
  null
  
)

export default component.exports